import React, { useEffect, useState } from 'react';
import RdvAffaire from "../../components/RdvAffaire";
import { CalendarDateRangeIcon } from "@heroicons/react/24/outline";
import { Link } from 'react-router-dom';


function TabsAffaireRdv(args) {
    //console.log("tabs rdv",args.transaction);
    const [rdv, setRdv] = useState(null);
    const [rdvNotaire, setRdvNotaire] = useState(null); // Stocke le RDV "Rendez vous notaire"
    const [rdvSignature, setRdvSignature] = useState(null);
    const [demandeRdv, setDemandeRdv] = useState(null);

    //get info RDV
    const getRdv = async () => {
        try {
            if (args.transaction !== null) {
                const URL = `https://api.airtable.com/v0/appD48APNaGA4GN0B/rdv?filterByFormula=SEARCH("${args.affaire.id}",{mariage})`;

                fetch(
                    URL,
                    {
                        method: "GET",
                        headers: {
                            Authorization: "Bearer patfRIUbOM9xqwLV2.dfbc9a305f2124aff75634c819a8335ecd984b1d19e98f67f14013378ed6bb02",
                            'content-type': 'application/x-www-form-urlencoded',
                            "Accept": "application/json, text/plain, /"
                        },
                    })
                    .then((res) => res.json())
                    .then((res) => {
                        //console.log("all rdv transaction", res.records);
                        const myDataSort = res.records.sort((a, b) =>
                            a.fields.sort < b.fields.sort ? -1 : 1
                        );
                        setRdv(myDataSort);
                        // 🔍 Trouver le RDV "Rendez vous notaire"
                        const rdvTrouve = res.records.find(rdv => rdv.fields.nom?.toLowerCase() === "rendez-vous notaire");
                        // ✅ Stocker les infos dans le state si trouvé
                        if (rdvTrouve) {
                            setRdvNotaire(rdvTrouve);
                        } else {
                            setRdvNotaire(null); // Aucun RDV trouvé
                        }
                        const rdvSignatureTrouve = res.records.find(r => r.fields.nom?.toLowerCase() === "rendez-vous de signature");
                        setRdvSignature(rdvSignatureTrouve || null);
                    })
                    .catch((error) => console.log(error));
            }
        } catch (e) {
            console.log(e);
        }
    };

    //get info RDV
    const getDemandeRdv = async () => {
        try {
            if (args.transaction !== null) {
                const URL = `https://api.airtable.com/v0/appD48APNaGA4GN0B/demande_rdv?filterByFormula=SEARCH("${args.affaire.id}",{id_affaire})`;

                fetch(
                    URL,
                    {
                        method: "GET",
                        headers: {
                            Authorization: "Bearer patfRIUbOM9xqwLV2.dfbc9a305f2124aff75634c819a8335ecd984b1d19e98f67f14013378ed6bb02",
                            'content-type': 'application/x-www-form-urlencoded',
                            "Accept": "application/json, text/plain, /"
                        },
                    })
                    .then((res) => res.json())
                    .then((res) => {
                        console.log("all demande_rdv transaction", res.records);
                        const myDataSort = res.records.sort((a, b) =>
                            a.fields.sort < b.fields.sort ? -1 : 1
                        );
                        setDemandeRdv(myDataSort);
                    })
                    .catch((error) => console.log(error));
            }
        } catch (e) {
            console.log(e);
        }
    };
    //get info RDV
    useEffect(() => {
        //get info rdv
        getRdv();
        getDemandeRdv();

    }, [args.transaction]);


    //console.log("demande", demandeRdv)
    
    if (rdv !== null && demandeRdv !== null) {
        return (
            <>
                <div>
                    <RdvAffaire type="mariage" idAffaire={args.affaire.id} notaireAirtableId={args.affaire.notaire[0]} affaire={args.affaire} rdvNotaire={rdvNotaire} rdvSignature={rdvSignature} refreshData={getRdv} />

                    {/** demande de rdv */}
                    {demandeRdv.length > 0 && (
                        <div className="mt-10 bg-white rounded-sm p-4 flex flex-row gap-2 items-center justify-between">
                            <div className='flex flex-row items-center gap-2'>
                                <CalendarDateRangeIcon className="size-12 text-gray-400" />
                                <div className="font-bold text-gray-900 ml-2">
                                    {demandeRdv[0].fields.date} <br />
                                    {demandeRdv[0].fields.heure_debut}h à {demandeRdv[0].fields.heure_fin}h
                                </div>
                            </div>
                            <div>
                                {demandeRdv[0].fields.type_rdv === "presentiel" && <>A l'étude</>}
                                {demandeRdv[0].fields.type_rdv === "telephone" && <> Par téléphone</>}
                                {demandeRdv[0].fields.type_rdv === "visio" && <> En visio</>}
                            </div>
                            <div>
                                {demandeRdv[0].fields.statut === "valide" &&
                                    <span className="inline-flex items-center rounded-md bg-emerald-100 px-2 py-1 text-xs font-bold text-emerald-800">
                                        Validée
                                    </span>
                                }
                                {demandeRdv[0].fields.statut === "attente validation" &&
                                    <span className="inline-flex items-center rounded-md bg-orange-100 px-2 py-1 text-xs font-bold text-orange-800">
                                        A valider
                                    </span>
                                }
                                {demandeRdv[0].fields.statut === "annule" &&
                                    <span className="inline-flex items-center rounded-md bg-red-100 px-2 py-1 text-xs font-bold text-red-800">
                                        Annulé
                                    </span>
                                }
                            </div>
                            <div className='flex flex-row gap-2'>
                                 <Link to={`/rdv/${demandeRdv[0].id}`} target="blank" className="btn-secondary rounded-full">Modifier</Link>
                                
                                                                                        <Link to={`/rdv/${demandeRdv[0].id}`} target="blank" className="btn-main">Valider</Link>
                            </div>
                        </div>
                    )}
                </div>
            </>
        );
    }
    return (<></>)
}

export default TabsAffaireRdv;
